var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-bar-end"},[_c('nav-buttons',{attrs:{"buttons":_vm.advertiserNavButtons}}),_c('user-menu-button',{attrs:{"user-info":_vm.userInfo,"drop-down-actions":_vm.dropDownActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }